import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M18 13c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zM17 2c1.1 0 2 .9 2 2v7.08c-.33-.05-.66-.08-1-.08-3.87 0-7 3.13-7 7 0 1.49.47 2.87 1.26 4H5c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2zm.51 13.98c-.33-.21-.76.03-.76.42v3.2c0 .39.43.63.76.43l2.56-1.6c.31-.2.31-.65 0-.85zM12 4H7v6.12c0 .39.42.63.76.43L9.5 9.5l1.74 1.05c.34.2.76-.04.76-.43z"
  }],
  circles: []
};
var PlayLessonIcon = function PlayLessonIcon(props) {
  return renderIcon(props, iconType);
};
export { PlayLessonIcon };